module.exports = __webpack_public_path__ + "static/media/decotype.3fac07a7.png";